import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadComponent: () => import('./components/login/login').then(m => m.Login)
  },
  {
    path: 'home',
    loadComponent: () => import('./components/dashboard/dashboard').then(m => m.Dashboard)
  },
  {
    path: 'selectii',
    loadComponent: () => import('./components/selections/selections').then(m => m.Selections)
  },
  {
    path: 'selectii/new',
    loadComponent: () => import('./components/create-selection/create-selection').then(m => m.CreateSelection)
  },
  {
    path: 'selectii/:id',
    loadComponent: () => import('./components/selection-details/selection-details').then(m => m.SelectionDetails)
  },
  {
    path: 'add-document',
    loadComponent: () => import('./components/add-document/add-document').then(m => m.AddDocument)
  },
  {
    path: 'rapoarte',
    loadComponent: () => import('./components/reports/reports').then(m => m.Reports)
  },
  {
    path: '404',
    loadComponent: () => import('./components/not-found/not-found').then(m => m.NotFound)
  },
  {
    path: '**',
    redirectTo: '404'
  }
];
